import { useStore } from "zustand";
import type { PackageWithLeaguesStore } from "../../store/packageWithLeaguesStore";
import usePackageWithLeaguesStoreApi from "../use-package-with-leagues-store-api";

export const usePackageWithLeaguesStore = <T>(selector: (state: PackageWithLeaguesStore) => T): T =>
  useStore(usePackageWithLeaguesStoreApi(), selector);

export default usePackageWithLeaguesStore;
